import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetProjectPerformanceSummaryQuery } from "../../../services/Reports";
import {
  getProjectsPerformanceSummaryRequest,
  getProjectsPerformanceSummaryFailure,
  getProjectsPerformanceSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allProjectsPerformanceSummary,
    isLoading: projectsPerformanceSummaryLoading,
    isError: projectsPerformanceSummaryError,
  } = useGetProjectPerformanceSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.projectsPerformanceSummaryPageNo,
    pageSize: state.projectsPerformanceSummaryPageSize,
    fromDate: new Date(
      state.projectsPerformanceSummaryFromDate,
    ).toLocaleDateString(),
    toDate: new Date(
      state.projectsPerformanceSummaryToDate,
    ).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectsPerformanceSummaryLoading) {
      dispatch(getProjectsPerformanceSummaryRequest());
    }
    if (projectsPerformanceSummaryError) {
      dispatch(
        getProjectsPerformanceSummaryFailure(projectsPerformanceSummaryError),
      );
    }
    if (allProjectsPerformanceSummary) {
      dispatch(
        getProjectsPerformanceSummarySuccess({
          data:
            allProjectsPerformanceSummary.data.projectPerformanceSummary[0]
              .data || [],
          totalPages:
            allProjectsPerformanceSummary.data.projectPerformanceSummary[0]
              .metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allProjectsPerformanceSummary,
    profileData,
    state.projectsPerformanceSummaryFromDate,
    state.projectsPerformanceSummaryToDate,
    state.projectsPerformanceSummaryPageNo,
    state.projectsPerformanceSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
